const SENSITIVE_KEY_RE =
  /^(password|passwd|secret|token|accessToken|refreshToken|authorization|cpf|cnpj|ssn|email|fullName|displayName|name|salary|netPay|api[_-]?key|client[_-]?secret)$/i;

const EMAIL_RE = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;
const CPF_RE = /\b\d{3}\.?\d{3}\.?\d{3}-?\d{2}\b/;

const REDACTED = "[REDACTED]";

export function isSensitiveTelemetryKey(key: string): boolean {
  return SENSITIVE_KEY_RE.test(key);
}

/** Remove PII/segredos de payloads enviados a Sentry/analytics. */
export function scrubTelemetryValue<T>(value: T, depth = 0): T {
  if (depth > 8 || value === null || value === undefined) return value;

  if (typeof value === "string") {
    if (EMAIL_RE.test(value) || CPF_RE.test(value)) return REDACTED as T;
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((item) => scrubTelemetryValue(item, depth + 1)) as T;
  }

  if (typeof value === "object") {
    const out: Record<string, unknown> = {};
    for (const [key, child] of Object.entries(value as Record<string, unknown>)) {
      out[key] = isSensitiveTelemetryKey(key)
        ? REDACTED
        : scrubTelemetryValue(child, depth + 1);
    }
    return out as T;
  }

  return value;
}

/** Falha se o JSON serializado ainda carregar campos sensíveis com valor real. */
export function assertNoPiiInTelemetry(serialized: string): void {
  const patterns: Array<{ label: string; re: RegExp }> = [
    { label: "email", re: /"email"\s*:\s*"(?!\[REDACTED\])[^"]+"/i },
    { label: "cpf", re: /"cpf"\s*:\s*"(?!\[REDACTED\])[^"]+"/i },
    { label: "password", re: /"password"\s*:\s*"(?!\[REDACTED\])[^"]+"/i },
    { label: "accessToken", re: /"accessToken"\s*:\s*"(?!\[REDACTED\])[^"]+"/i },
    { label: "displayName", re: /"displayName"\s*:\s*"(?!\[REDACTED\])[^"]+"/i },
    { label: "salary", re: /"salary"\s*:\s*(?!null)(?!"\[REDACTED\]")[^,}\s]+/i },
    {
      label: "authorization",
      re: /"authorization"\s*:\s*"(?!\[REDACTED\])[^"]+"/i,
    },
  ];
  for (const { label, re } of patterns) {
    if (re.test(serialized)) {
      throw new Error(`PII vazou na telemetria: campo ${label}`);
    }
  }
}
